import React from 'react';
import notFoundImage from './404notfound.png';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
      <img
        src={notFoundImage}
        alt="404 Not Found"
        className="w-full max-w-md mb-8 animate-pulse"
        loading="eager"
      />
      <h1 className="text-2xl font-bold text-gray-800 font-AndoraModernSerif">Page Not Found</h1>
      <p className="text-gray-500 mt-2">The page you're looking for doesn't exist.</p>
      <a
        href="/"
        className="mt-6 px-6 py-2 bg-pumpkinToast-500 text-white rounded-lg hover:bg-pumpkinToast-600 transition-colors"
      >
        Go Home
      </a>
    </div>
  );
}
